/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_assessment-complete': {
    width: 26,
    height: 33,
    viewBox: '0 0 26 33',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M19.287 5.077h3.518c1.4 0 2.534 1.136 2.534 2.538v22.846A2.536 2.536 0 0122.805 33H2.533A2.536 2.536 0 010 30.462V7.614a2.536 2.536 0 012.533-2.538h3.518a3.788 3.788 0 011.763-1.12 1.748 1.748 0 001.202-1.204A3.804 3.804 0 0112.669 0a3.804 3.804 0 013.654 2.753 1.745 1.745 0 001.2 1.203 3.8 3.8 0 011.764 1.12zm-5.335-1.27a1.268 1.268 0 10-1.267 1.27c.7 0 1.267-.568 1.267-1.27zm-3.73 20.473L19.483 15l2.356 2.36L10.221 29 4 22.851l2.355-2.362 3.866 3.791z" _fill="#fff"/>'
  }
})
